const UploadPDFStyle = theme => ({
    wrapper: {
        display: "flex",
        flex: 1,
        position: "relative"
    },
    contentWrapper: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        margin: "20px 0"
    },
    headerSection: {
        display: "flex",
        width: "100%",
        borderBottom: "1px solid #EDEDED"
    },
    headerToggleStyle: {
        paddingLeft: 43
    },
    scrollSection: {
        overflow: "auto"
    },
    patientInfoWrapper: {
        display: "flex",
        color: "#242424",
        marginBottom: 15,
        marginLeft: 20,
        minHeight: "40px",
    },
    borderSection: {
        borderBottom: "2px solid #EEF1F1"
    },
    imageWrapper: {
        color: "#242424",
        width: "100%",
        marginBottom: 15
    },
    simpleHeadingText: {
        fontFamily: "Proxima Nova",
        fontSize: "30px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "37px"
    },
    patientNameText: {
        fontWeight: "bold",
        marginLeft: "10px",
        fontFamily: "Proxima Nova",
        fontSize: "30px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "37px"
    },
    subheadingText: {
        fontFamily: "Proxima Nova",
        marginLeft: "20px",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "40px"
    },
    imageInfoWrapper: {
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        letterSpacing: 0,
        backgroundColor: "#eef1f1",
        lineHeight: "20px",
        color: "#242424",
        display: "flex",
        padding: 10,
        width: "100%"
    },
    dateText: {
        fontWeight: "bold",
        marginLeft: 12
    },
    questionText: {
        marginLeft: 20
    },
    imageshowWrapper: {
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "20px",
        color: "#242424",
        display: "flex",
        width: "100%",
        marginLeft: -15,
        marginBottom: 40,
        marginTop: 20,
    },
    imageDisplayWrapper: {
        Height: "200px",
        Width: "400px",
        minWidth: "400px",
        maxWidth: "400px",
        backgroundColor: "white",
        border: "none"
    },
    imageDisplay: {
        maxHeight: "200px",
        maxWidth: "300px",
        marginLeft: 40,
        border: "1px solid #979797 !important",
        cursor: "pointer"
    },
    imageDefaultWrapper: {
        minHeight: "200px",
        minWidth: "300px",
        maxHeight: "200px",
        maxWidth: "300px",
        marginLeft: 40,
        border: "1px solid #979797 !important",
        backgroundColor: "#EFEFEF",
        display: "flex",
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
    },
    imageDefault: {
        height: "60px",
        weight: "60px",
        marginBottom: "30px"
    },
    imageDefaultLabel: {
        color: "#FF0000",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    imageLargeDisplay: {
        maxHeight: "700px",
        maxWidth: "1000px",
        marginLeft: 40,
        border: "1px solid #979797 !important",
        cursor: "pointer",
        marginTop: -30,
    },
    imageLabel: {
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px"
    },
    noPdfContent: {
        padding: "20vh",
        textAlign: "center",
        fontWeight: "800",
        fontSize: "4vh",
    }
})


export default UploadPDFStyle;